// extracted by mini-css-extract-plugin
module.exports = {"card":"CSQuoteCard_card__3zss4","content":"CSQuoteCard_content__eBvfk"};